import { render, staticRenderFns } from "./MemberConnections.vue?vue&type=template&id=d074e134"
import script from "./MemberConnections.vue?vue&type=script&lang=js"
export * from "./MemberConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports